import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import * as widgetsActions from "../../../../redux/Widgets/actions";
import Pyramid from "../../../../components/Charts/Pyramid";
import ViewReportLink from "../ViewReportLink.js";

const widgetName = "Pilot";

const Pilot = props => {
	const widget = useSelector(state => state.widget).widgets[widgetName];
	const user = useSelector(state => state.user.user);

	const dispatch = useDispatch();
	const getOrder = type => {
		switch(type) {
			case "Outreach":
				return 0;
			case "Qualification":
				return 1;
			case "Cloud Engagement":
				return 2;
			case "Customer Intro":
				return 3;
			case "Customer Engagement":
				return 4;
			case "POV":
				return 5;
			case "Proposal/Price Quote":
				return 6;
		}
	};

	useEffect(() => {
		const load = async () => {
			await dispatch(widgetsActions.loadWidget(widgetName))
		};
		load();
	}, [user]);

	const loading = widget == null || widget.status === "loading" || widget.data == null || widget.data.data == null ;

	if(loading) {
		return (
			<div />
		)
	}

	const colors = ["#40A0C1", "#237389", "#126480", "#FFC267", "#FF9E67", "#F37249", "#BF533B", "#FF9090", "#E2E7ED"];

	let result = {};
	widget.data?.data?.forEach(opp => {
		if(!result[opp.StageName]) {
			result[opp.StageName] = 1;
		}
		else {
			result[opp.StageName]++;
		}
	});

	const items = Object.keys(result).map(k => ({type: k, order: getOrder(k), value: result[k]}));
	let total = 0;
	items.forEach(item => total += item.value);
	items.forEach(item => item.percent = (Math.round(item.value / total * 10000) / 100));

	const layers = items
		.sort((a, b) => a.order - b.order)
		.map((item, i) => ({
			label: `${item.value} (${item.percent}%)`,
			legendLabel: `${item.type} ${item.value} (${item.percent}%)`,
			color: colors[i],
			value: item.value
		}));

	return (
		<div className="widget-container">
			<div className="widget-title">Pilot ({total})</div>
			<Pyramid data={layers} width={270} height={450} />
			<ViewReportLink onClick={() => props.showReport(widget)} />
		</div>
	)
};

export default Pilot;